import styled from 'styled-components'
import media from 'media'

const ButtonContainer = styled.div.attrs({})`
  display: inline-grid;
  margin: 20px 0;
  gap: 20px;
  position: relative;
  z-index: 10;

  ${media.desktop`
    max-width: 400px;
    display: grid;
    grid-template-columns: 1fr 1fr;
  `}
`

// TODO: displayBreakpointify this
export const BaseButtonContainer = styled(ButtonContainer)`
  margin-left: auto;
  margin-right: auto;
  width: 100%;

  ${media.desktop`
    max-width: 400px;
    display: grid;
    grid-template-columns: 1fr 1fr;
  `}
`

export const HeroButtonContainer = styled(BaseButtonContainer)`
  ${media.desktop`
    margin-left: unset;
    margin-right: unset;
  `}
`
